var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { fetchFinalChargeslogSuccess, fetchFinalChargeslogFailure, FETCH_FINAL_CHARGES_REQUEST } from "../../actions";
import APIIN from "@/utils/APIIN";
const onFetchFinalChargesLog = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { pageSize, pageNumber, billingCycle } = action.payload;
            console.log("selectedBilling", billingCycle);
            const encodedBillingCycle = encodeURIComponent(action.payload.billingCycle);
            APIIN.get(`/report/admin/charges?billingDate=${encodedBillingCycle}&pageSize=${pageSize}&pageNumber=${pageNumber}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchFinalChargesLogWorker(action) {
    try {
        const data = yield call(onFetchFinalChargesLog, action);
        yield put(fetchFinalChargeslogSuccess(data));
    }
    catch (error) {
        yield put(fetchFinalChargeslogFailure(error));
    }
}
export function* watchFinalChargesLogData() {
    yield takeLatest(FETCH_FINAL_CHARGES_REQUEST, fetchFinalChargesLogWorker);
}
